import { IDeleteItemMedicaoUseCase } from "../../../presentation/useCases/delete/delete_item_medicao_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// DeleteItemMedicaoUseCase

export class DeleteItemMedicaoUseCase implements IDeleteItemMedicaoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async deleteItemMedicao(IdItemMedicaoTerceirizacao: number): Promise<void> {
    await this.repository.deleteItemMedicao(IdItemMedicaoTerceirizacao);
  }
}
